import { dynamicApiSlice } from "../dynamicApi";
import type { SystemThought } from "@/types/SystemThought";

export const workflowStepInstanceSystemThoughtsApi =
  dynamicApiSlice.injectEndpoints({
    endpoints: (builder) => ({
      getWorkflowStepInstanceThoughts: builder.query<
        SystemThought[],
        { workflowInstanceId: string; workflowStepInstanceId: string }
      >({
        query: ({ workflowInstanceId, workflowStepInstanceId }) =>
          `/${encodeURIComponent(workflowInstanceId)}/${encodeURIComponent(
            workflowStepInstanceId,
          )}/thoughts`,
        transformResponse: (response: SystemThought[]) =>
          response.filter(
            (thought, index, thoughts) =>
              index === 0 || thought.title !== thoughts[index - 1].title,
          ),
        providesTags: (_result, _err, arg) => [
          {
            type: "WorkflowStepInstanceThoughts" as const,
            id: `${arg.workflowInstanceId}-${arg.workflowStepInstanceId}`,
          },
        ],
      }),
      getSystemThought: builder.query<
        SystemThought,
        { workflowInstanceId: string; systemThoughtId: string }
      >({
        query: ({ workflowInstanceId, systemThoughtId }) =>
          `/${encodeURIComponent(
            workflowInstanceId,
          )}/thoughts/${encodeURIComponent(systemThoughtId)}`,
      }),
    }),
  });

export const {
  useGetWorkflowStepInstanceThoughtsQuery,
  useGetSystemThoughtQuery,
} = workflowStepInstanceSystemThoughtsApi;
